import React, {
  useCallback, useMemo, useState, useEffect,
} from 'react';
import * as Styles from './AiBuilderMyBusiness.styles';
import { SearchBusinesses } from './components/SearchBusinesses';
import promoImage from '@/media/onboarding/aiBuilder/my-business-step.png';
import { IconButton } from 'gatorcomponents';
import { useResize } from '@/hooks/useResize';
import { LoadingContent } from '../LoadingScreen';
import starImage from '@/media/onboarding/aiBuilder/star-to-background.png';

const AiBuilderMyBusiness = ({
  locales,
  onContinue,
  onGoBack,
  onChangeInput,
  businessList,
  createSiteState,
  builderProvisioningLoading,
  redirectSuccessPageAiBuilder,
}) => {
  const [businessesInputValue, setBusinessesInputValue] = useState({});

  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width < 600;

  const projectData = useMemo(() => ({
    company: businessesInputValue.company || '',
    google_place_id: businessesInputValue.google_place_id || '',
  }), [businessesInputValue]);

  const handleGoBack = () => {
    onGoBack && onGoBack();
  };

  const handleCreateSite = useCallback(() => {
    onContinue && onContinue({
      projectData,
    });
  }, [onContinue, projectData]);

  const handleCloseOnSuccess = useCallback(() => {
    if (createSiteState.status === 'success') {
      redirectSuccessPageAiBuilder && redirectSuccessPageAiBuilder();
    }
  }, [createSiteState.status, redirectSuccessPageAiBuilder]);

  useEffect(() => {
    handleCloseOnSuccess();
  }, [handleCloseOnSuccess]);

  const handleChangeInput = useCallback((value) => {
    onChangeInput && onChangeInput(value);
  }, [onChangeInput]);

  const searchBusinessesProps = useCallback(() => ({
    businessesLocale: locales.content,
    continueButtonClick: handleCreateSite,
    onGoBack,
    handleChangeInput,
    businessList,
    businessesInputValue,
    setBusinessesInputValue,
    mobile,
  }), [
    locales.content,
    handleCreateSite,
    handleChangeInput,
    businessList,
    onGoBack,
    businessesInputValue,
    setBusinessesInputValue,
    mobile,
  ]);

  if (builderProvisioningLoading || (createSiteState && createSiteState.loading)) {
    return <LoadingContent locales={locales} />;
  }

  return (
    <Styles.Wrapper data-testid="ai-builder-my-business">
      <Styles.ButtonBackWrapper>
        <IconButton
          testId="ai-builder-my-business-button-back"
          icon="IconArrow"
          onClick={handleGoBack}
          size="sm"
          color="lowDark"
        />
      </Styles.ButtonBackWrapper>

      <Styles.PromoPanel>
        <Styles.PromoPanelInner>
          <Styles.PromoTitleContainer>
            <Styles.PromoTitle>
              {locales.promoBannerTitle}
            </Styles.PromoTitle>
          </Styles.PromoTitleContainer>

          <Styles.PromoImage src={promoImage} alt="promo banner" />
        </Styles.PromoPanelInner>
        <Styles.StarImage src={starImage} alt="loading-star" />
      </Styles.PromoPanel>


      <Styles.FormContainer data-testid="ai-builder-my-business-form-container">
        <Styles.FormContent>
          <SearchBusinesses {...searchBusinessesProps()} />
        </Styles.FormContent>
      </Styles.FormContainer>
    </Styles.Wrapper>
  );
};

export default AiBuilderMyBusiness;
